<template lang="pug">
.content.rule-action-group
    .row(ref='actionRaw')
      .col-md-12 
      .well.well-sm
        div.row
          label.col-md-1 THEN

          ed-select.col-md-5.middle(
            :options='actionOperators'
            v-model='actionOperatorModel'
            @select='changeOperator($event)'
          )

          slot(name='delete-action')

          div.row(v-for='(action, i) in processedActions' :key='i')
            ed-select.col-md-3(
              :options='action.actionValues'
              v-model="action.__selectedContextType",
              label='label'
              placeholder='Select action context',
              @select="resetActionLine(action, $event)"
            )

            ed-select.col-md-3(
              placeholder='Select operator'
              :options='operators'
              v-model='operatorType[action.Operator]'
              @select="changeActionOperator(action, $event)"
            )

            ed-select.col-md-3(
              placeholder='Select action'
              :openEndpoint='api.$.approval.getItemOwnerValues'
              multiple
              checkboxes
              multilist
              :options='action.__o'
              groupLabel='label'
              groupValues='options'
              label='Name'
              trackBy='Uid'
              disableSelected
              :globalSelectedValues='__selectedGlobalOptions'
              :selectedValues='action.__selectedOp'
              v-model='action.__selectedOptions'
              @apply='setActionOptions(action, $event)'
              @open='action.__selectedContextType && getOptions(action, $event)'
            )
              div(slot='additionalOptions')
                ed-checkbox(:options='action.__selectedAdditionalOptions')
            //- p __selectedAdditionalOptions {{action.__selectedAdditionalOptions}}
            //- p __selectedContextType {{action.__selectedContextType}}
            //- p __selectedOptions {{action.__selectedOptions}}
            //- p action.__o {{action.__o}}
            .col-md-3.icon-bar
              div.fas.fa-trash-alt.pull-right(@click='deleteConditionModal(action)')
              div.fas.fa-copy.pull-right(@click='copyActionLine(i)')
              ed-select.col-md-6(
                v-if='useParallelApprovalRoutes && action.__selectedContextType.label === "Request Approval From"'
                placeholder='Select route'
                :options='routeValues'
                label='label'
                v-model='action._parallelRouteNo'
                @select='changeRouteNo(action, $event)'
              )

    ed-modal(
      :show='showDeleteModal' 
      @close='showDeleteModal = false'
      @confirm='deleteActionLine()'
      title=''
      subtitle='Are you sure you want to delete this action?'
      primaryButton='Yes'
      secondaryButton='No'
      type='small'
    )
</template>

<script>
import type from './type'
import optionType from './option-type'
import actionAddOptions from './action-add-options'
import teamTabType from './team-tab-type'
import contextType from './context-type'
import operatorType from './operator-type'
import checkbox from '@/core/components/edCheckbox/checkbox.vue'
import optionRules from './option-rules'
import { EventBus } from '@/event-bus'
import events from '@/core/events/events'
import routesValues from './route-values'
var approvalRuleUtils = require('./approvalRuleUtils')

export default {
  components: {
    'checkbox': checkbox
  },

  props: {
    actions: Object,
    rule: Object,
    actionOptions: Object,
    routeValues: Array,
    useParallelApprovalRoutes: Boolean
  },

  data () {
    return {
      actionOperators: [
        'Perform all of the following actions step by step',
        'Perform all of the following actions simultaneously'
      ],
      processedActions: [],
      list: utils.collection.list,
      max: utils.collection.max,
      showDeleteModal: false,
      deleteTarget: null,
      contextType,
      operatorType,
      routesValues,
      actionAddOptions,
      xsi: '@xsi:type',
      resultOptions: [],
      contextTypeMap: Object.keys(contextType),
      operatorTypeMap: Object.keys(operatorType),
      routesValuesMap: Object.keys(routesValues.routeNumber),
      values: action => {
        var result = []
        if (action.Roles && action.Roles[type.role]) {
          var roles = this.list(action.Roles[type.role]).filter(key => key.IsTeamTabRole === 'false' && key.IsUserTitle !== 'true').map(role => {
            role = {
              Name: role.Name,
              Id: parseInt(role.RoleId)
            }
            return role
          })
          var teamTabRoles = this.list(action.Roles[type.role]).filter(key => key.IsTeamTabRole === 'true').map(role => {
            role = {
              Name: role.Name,
              Id: parseInt(role.RoleId),
              Key: role.TeamTabRole
            }
            return role
          })
          var usersTitles = this.list(action.Roles[type.role]).filter(key => key.IsUserTitle === 'true').map(role => {
            role = {
              Name: role.Name,
              Id: parseInt(role.RoleId)
            }
            return role
          })
          if (roles.length) {
            result.push({
              label: optionType['Roles'],
              type: 'Roles',
              options: roles
            })
          }
          if (teamTabRoles.length) {
            result.push({
              label: optionType['TeamTabRoles'],
              type: 'TeamTabRoles',
              options: teamTabRoles
            })
          }
          if (usersTitles.length) {
            result.push({
              label: optionType['UsersTitles'],
              type: 'UsersTitles',
              options: usersTitles
            })
          }
        }
        if (action.Users && action.Users[type.user]) {
          var users = this.list(action.Users[type.user]).map(user => {
            user = {
              Name: user.FirstName + ' ' + user.LastName,
              Id: parseInt(user.UserID)
            }
            return user
          }) || []
          result.push({
            label: optionType['Users'],
            type: 'Users',
            options: users
          })
        }
        this.resultOptions = result.GroupValues
        return result
      },
      __selectedGlobalOptions: [],
      optionRules,
      componentDestroyed: false,
      useHierarchyApproval: this.$user.$.companySettings && this.$user.$.companySettings.UseHierarchyApproval
    }
  },
  created() {
    EventBus.$on('rootOptionChanged', limitation => {
      this.rootOptionsChangedEvent()
    })

    this.processActions()

    EventBus.$on(events.APPROVAL_RULE.VALIDATE_COMPONENTS, r => {
      this.validateRule()
    })

    EventBus.$on('usingParallelRoutesChanged', r => {
      this.usingParallelRoutesChangedEvent(r)
    })

    EventBus.$on('updateMaxRoutesChanged', r => {
      this.updateMaxRoutesChangedEvent(r)
    })
  },

  // solution from this link does not work
  // https://stackoverflow.com/questions/45399302/stop-receiving-events-from-destroyed-child-component
  beforeDestroy() {
    this.componentDestroyed = true
  },

  computed: {
    operators() {
      var operators = []
      if (this.actionOptions.Operators) {
        for (var i = 0; i < this.actionOptions.Operators.length; i++) {
          operators.push(operatorType[this.actionOptions.Operators[i]])
        }
      }
      return operators
    },

    actionOperatorModel() {
      if (this.rule && this.rule.ActionOperator) {
        return this.rule.ActionOperator === 'StepByStep' ? this.actionOperators[0] : this.actionOperators[1]
      }
    },

    programLabel() {
      return global.app.$user.sessionSettings.CompanySettings.ProgramLabel
    }
  },

  methods: {
    validateRule() {
      if (!this.componentDestroyed) {
        let valid = true

        if (this.actions && this.actions[type.action]) {
          if (this.list(this.actions[type.action]).length === 0) {
            valid = false
          }

          if (!this.rule.ActionOperator) {
            valid = false
          }

          let actionsList = this.list(this.actions[type.action])
          actionsList.map(action => {
            let hasNotCompletedParallelRoutes = action['@xsi:type'] === type.requestApprovalAction && this.useParallelApprovalRoutes ? action.ParallelRouteNo === null : false
            if (!action['@xsi:type'] || !action.Operator || hasNotCompletedParallelRoutes) {
              valid = false
            } else {
              // verify if any role/user is set on action
              let missingRoles = false
              let missingUsers = false
              if (!action.Roles || (action.Roles && (!action.Roles[type.role] || this.list(action.Roles[type.role]).length === 0))) {
                missingRoles = true
              }
              // verify if any user is set on action
              if (!action.Users || (action.Users && (!action.Users[type.user] || this.list(action.Users[type.user]).length === 0))) {
                missingUsers = true
              }
              if (missingRoles && missingUsers) {
                valid = false
              }
            }

            let payload = {
              Id: action.Id,
              valid: valid
            }
            EventBus.$emit(events.APPROVAL_RULE.VALIDATION_COMPLETED, payload)
          })
        }

        if (!valid) {
          this.invalidateConditionBlock()
        } else {
          this.resetConditionBlock()
        }
      }
    },

    invalidateConditionBlock() {
      if (this.$refs.actionRaw && this.$refs.actionRaw.classList) {
        this.$refs.actionRaw.classList.add('invalid')
      }
    },

    resetConditionBlock() {
      if (this.$refs.actionRaw && this.$refs.actionRaw.classList) {
        this.$refs.actionRaw.classList.remove('invalid')
      }
    },

    rootOptionsChangedEvent() {
      if (this.$store.state[optionRules.PoCancelledClosedSelected]) {
        this.processedActions = this.processedActions.map(action => {
          for (let [i, value] of action.actionValues.entries()) {
            if (value.label === this.contextType[type.requestApprovalAction]) {
              action.actionValues.splice(i, 1)
              break
            }
          }
          action.__selectedAdditionalOptions = action.__selectedContextType !== '' ? this.getAdditionalOptions(action) : []
          return action
        })
      } else {
        this.processedActions = this.processedActions.map(action => {
          let alreadyContainsItem = false
          action.actionValues.map(actionValue => {
            if (actionValue.label === this.contextType[type.requestApprovalAction]) {
              alreadyContainsItem = true
            }
          })
          if (!alreadyContainsItem) {
            action.actionValues.push({
              label: this.contextType[type.requestApprovalAction],
              values: [{label: '', options: []}]
            })
          }
          action.__selectedAdditionalOptions = action.__selectedContextType !== '' ? this.getAdditionalOptions(action) : []
          return action
        })
        if (this.$store.state[optionRules.PoSelected]) {
          this.processedActions = this.processedActions.map(action => {
            let alreadyContainsItem = false
            action.actionValues.map(actionValue => {
              if (actionValue.label === this.contextType[type.notify]) {
                alreadyContainsItem = true
              }
            })
            if (!alreadyContainsItem) {
              action.actionValues.push({
                label: this.contextType[type.notify],
                values: [{label: '', options: []}]
              })
            }
            action.__selectedAdditionalOptions = action.__selectedContextType !== '' ? this.getAdditionalOptions(action) : []
            return action
          })
        } else {
          this.processedActions = this.processedActions.map(action => {
            for (let [i, value] of action.actionValues.entries()) {
              if (value.label === this.contextType[type.notify]) {
                action.actionValues.splice(i, 1)
                break
              }
            }
            action.__selectedAdditionalOptions = action.__selectedContextType !== '' ? this.getAdditionalOptions(action) : []
            return action
          })
        }
      }
    },

    usingParallelRoutesChangedEvent(r) {
      this.processedActions = this.processedActions.map(action => {
        var updatedAction = utils.copy(action)
        this.$store.state.routeNumbers = []
        if (!r.data) {
          updatedAction.ParallelRouteNo = null
        } else {
          updatedAction.ParallelRouteNo = action['@xsi:type'] === type.requestApprovalAction ? action._parallelRouteNo.id : null
          if (action['@xsi:type'] === type.requestApprovalAction && typeof action._parallelRouteNo !== 'undefined' && parseInt(action._parallelRouteNo.id) !== null) {
            this.$store.state.routeNumbers.push(action._parallelRouteNo.id)
          }
        }
        this.updateAction(action.Id, updatedAction)
        return action
      })
    },

    updateMaxRoutesChangedEvent(r) {
      this.processedActions = this.processedActions.map(action => {
        if (action['@xsi:type'] === type.requestApprovalAction && action._parallelRouteNo.id > parseInt(r.data)) {
          this.$store.state.routeNumbers.splice(this.$store.state.routeNumbers.indexOf(action._parallelRouteNo.id), 1)
          action.ParallelRouteNo = null
          action._parallelRouteNo = { label: '', id: null }
          var updatedAction = utils.copy(action)
          this.updateAction(action.Id, updatedAction)
        }
        return action
      })
    },

    getOriginalAdditionalOptions(action) {
      let options = this.actionOptions.AdditionalOptions
      .filter(option => (!this.useHierarchyApproval && option !== 'UseHierarchyApproval') || this.useHierarchyApproval)
      .map(option => {
        option = {
          id: option,
          label: actionAddOptions[option],
          status: (action[option] && action[option].toString() === 'true'),
          originalStatus: action[option] && action[option].toString() === 'true',
          hide: false
        }
        return option
      })
      return options
    },

    getAdditionalOptions(action) {
      let options = this.getOriginalAdditionalOptions(action)
      let copyOptions = utils.copy(options)
      if (this.$store.state[optionRules.InvoiceSelected]) {
        copyOptions = copyOptions.filter(option => option.id !== 'RequestEveryTime')
      }
      if (!this.$store.state[optionRules.ProgramBudgetSelected]) {
        copyOptions = copyOptions.filter(option => option.id !== 'UseHierarchyApproval')
      }
      options = copyOptions

      return options
    },

    applyActionContext(action, index) {
      action.__selectedAdditionalOptions = []
      action.__selectedOptions = []
      action.__selectedContextType = ''
      action.__o = [{}]
      action.__selectedOp = []

      action.actionValues = []

      if (this.actionOptions && this.actionOptions.Options) {
        // limitate THEN options based on internal rules
        this.actionOptions = this.limitateOptions(this.actionOptions)
        this.actionOptions.Options.map((option, index) => {
          // this.$store.state.rootOptionSelected = o
          action.actionValues.push({
            label: this.$t(contextType[option.Type]),
            values: option.Type === action['@xsi:type'] ? this.values(action) : [{label: '', options: []}]
          })
          if (option.Type === action['@xsi:type']) {
            action.__selectedContextType = action.actionValues[index]
          }
        })
        if (action.__selectedContextType !== '') {
          action.__selectedAdditionalOptions = this.getAdditionalOptions(action)
        }
      }
      action._parallelRouteNo = typeof action.ParallelRouteNo !== 'undefined' && this.useParallelApprovalRoutes ? {label: this.routesValuesMap.filter(key => routesValues.routeNumber[key] === action.ParallelRouteNo)[0], id: parseInt(action.ParallelRouteNo)} : {label: '', id: null}
      action.ParallelRouteNo = action._parallelRouteNo.id
      this.$store.state.routeNumbers.push(action._parallelRouteNo.id)
      // set initial values
      // TODO: get default group
      this.markGroupOptions({ data: '{"Roles": []}' }, action, true)

      return action
    },

    limitateOptions(actionOptions) {
      // get original options from $store
      this.actionOptions.Options = utils.copy(this.$store.state.originalActionOptions.options)
      this.actionOptions.AdditionalOptions = utils.copy(this.$store.state.originalActionOptions.additionalOptions)
      for (let [i, value] of actionOptions.Options.entries()) {
        if (this.$store.state[optionRules.PoCancelledClosedSelected]) {
          if (value.Type === type.requestApprovalAction) {
            actionOptions.Options.splice(i, 1)
          }
        } else {
          if (!this.$store.state[optionRules.PoSelected]) {
            if (value.Type === type.notify) {
              actionOptions.Options.splice(i, 1)
            }
          }
        }
      }
      if (this.$store.state[optionRules.InvoiceSelected]) {
        actionOptions.AdditionalOptions.filter(option => option !== 'RequestEveryTime')
      }
      if (!this.$store.state[optionRules.ProgramBudgetSelected]) {
        actionOptions.AdditionalOptions.filter(option => option !== 'UseHierarchyApproval')
      }
      return actionOptions
    },

     /*
     * 1. init action model
     */
    processActions() {
      var vm = this
      this.__selectedGlobalOptions = []
      this.processedActions = this.list(utils.copy(this.actions[type.action])).map((action, index) => {
        action = vm.applyActionContext(action, index)
        return action
      })
    },

    /*
     * 2. fetch all options
     */
    getOptions(action) {
      let vm = this
      let endpoint = this.api.$.approval.getItemOwnerValues
      let payload = {type: action['@xsi:type']}
      // call api
      endpoint && this.api.forms.post(endpoint, payload).then(r => {
        if (r && r.data) {
          vm.markGroupOptions(r, action, false)
        }
      })
    },

     /*
     * 3. mark existing options
     */
    markGroupOptions(r, action, isInitiallySetting) {
      let resultObj = JSON.parse(r.data)
      let initialSelected = action.__selectedContextType.values
                            ? action.__selectedContextType.values
                              .map(flagSaved)
                              .reduce((selectedOptions, value) => selectedOptions.concat(value), [])
                              : []

      let newAction = [{ label: '', values: [{label: '', options: []}] }]
      Object.keys(resultObj).map((key, i) => {
        var res = resultObj[key].map(k => {
          k.Uid = k.Id + '_' + key
          k.Type = key
          k.Name = this.formatLabel(k.Name)
          return k
        })

        newAction = action.actionValues.filter(v => v.label === contextType[action['@xsi:type']])[0]
        action.__selectedOptions = action.__selectedOptions.length
                                    ? action.__selectedOptions
                                    : initialSelected
        if (isInitiallySetting) {
          action.__selectedOp = utils.copy(action.__selectedOptions)
        }
        action.__selectedOptions.map(option => {
          if (this.__selectedGlobalOptions.filter(o => o.Uid === option.Uid).length === 0 && (isInitiallySetting ? true : action.__selectedOp.filter(o => o.Uid === option.Uid).length !== 0)) {
            this.__selectedGlobalOptions.push(option)
          }
        })

        if (newAction) {
          var verification =
            (!this.useHierarchyApproval && key !== 'UsersTitles') ||
            (this.useHierarchyApproval &&
              (
                (!this.$store.state[optionRules.ProgramBudgetSelected] && key !== 'UsersTitles') ||
                this.$store.state[optionRules.ProgramBudgetSelected]
              )
            )

          if (verification) {
            if (newAction.values[i]) {
              newAction.values[i].label = optionType[key]
              newAction.values[i].options = res
            } else {
              newAction.values.push({
                label: optionType[key],
                options: res
              })
            }
          }
        }
      })
      newAction && this.setOptions(action, newAction)

      function flagSaved(val) {
        return val.options.map(k => {
          k.Uid = k.Id + '_' + val.type
          k.Type = val.type
          // k.Key = k.Key
          return k
        })
      }
    },

    setOptions(action, e) {
      action.__o = e.values
      e.values = [{label: '', options: []}]
    },

    getTeamTabType(searchKey) {
      let result = searchKey
      Object.keys(teamTabType).map(key => {
        let keyF = key.replace('[placeholder]', global.app.$user.sessionSettings.CompanySettings.ProgramLabel)
        if (keyF === searchKey) {
          result = teamTabType[key]
        }
      })
      return result
    },

    setActionOptions(action, e) {
      this.enableSaveButton()

      const RolesList = []
      const UsersList = []

      action.__selectedOptions.map(selectedOption => {
        if (this.__selectedGlobalOptions.filter(o => o.Uid === selectedOption.Uid).length === 0) {
          this.__selectedGlobalOptions.push(selectedOption)
        }
        this.processedActions.map(processedAction => {
          if (processedAction.Id !== action.Id) {
            processedAction.__selectedOptions.map((option, index) => {
              if (option.Uid === selectedOption.Uid) {
                processedAction.__selectedOptions.splice(index, 1)
              }
              return option
            })
            return processedAction
          }
        })
        switch (selectedOption.Type) {
          case 'Roles':
            RolesList.push({
              RoleId: selectedOption.Id,
              TeamTabRole: this.getTeamTabType(this.programLabel + ' Owner'), // Program Owner
              CustomTitleId: 0,
              Name: selectedOption.Name,
              IsTeamTabRole: 'false',
              IsUserTitle: 'false'
            })
            break

          case 'TeamTabRoles':
            var teamTabText = ''
            if (selectedOption.Key === this.getTeamTabType('Meeting Requestor')) {
              teamTabText = this.getTeamTabType('Meeting Requestor')
            } else {
              if (selectedOption.Id >= 0) {
                teamTabText = this.getTeamTabType(selectedOption.Name)
              } else {
                teamTabText = this.getTeamTabType('Custom Title')
              }
            }
            RolesList.push({
              RoleId: selectedOption.Id,
              TeamTabRole: teamTabText,
              CustomTitleId: (selectedOption.Id >= 0 ? selectedOption.Id : ((-1) * selectedOption.Id)),
              Name: selectedOption.Name,
              IsTeamTabRole: 'true',
              IsUserTitle: 'false'
            })
            break

          case 'Users':
            UsersList.push({
              UserID: selectedOption.Id,
              RoleID: 0,
              FirstName: selectedOption.Name.split(' ')[0],
              LastName: selectedOption.Name.split(' ')[1]
            })
            break

          case 'UsersTitles':
            RolesList.push({
              RoleId: selectedOption.Id,
              TeamTabRole: this.getTeamTabType(this.programLabel + ' Owner'), // Program Owner
              CustomTitleId: 0,
              Name: selectedOption.Name,
              IsTeamTabRole: 'false',
              IsUserTitle: 'true'
            })
            break
        }
      })

      action.__selectedAdditionalOptions = action.__selectedAdditionalOptions.map(selectedOption => {
        selectedOption.originalStatus = selectedOption.status
        switch (selectedOption.id) {
          case 'MatchBusinessUnit':
            action.MatchBusinessUnit = selectedOption.originalStatus
            break
          case 'MatchCostCenter':
            action.MatchCostCenter = selectedOption.originalStatus
            break
          case 'OverridePreviousSteps':
            action.OverridePreviousSteps = selectedOption.originalStatus
            break
          case 'RequestEveryTime':
            action.RequestEveryTime = selectedOption.originalStatus
            break
          case 'UseHierarchyApproval':
            action.UseHierarchyApproval = selectedOption.originalStatus
            break
        }

        // even though the options do not appear in UI
        // we need to save them in the approval XML with false values
        if (this.$store.state[optionRules.InvoiceSelected]) {
          action.RequestEveryTime = false
        }
        if (!this.useHierarchyApproval || !this.$store.state[optionRules.ProgramBudgetSelected]) {
          action.UseHierarchyApproval = false
        }

        return selectedOption
      })

      if (RolesList.length > 0) {
        if (!action.Roles) {
          action.Roles = {}
        }
        action.Roles[type.role] = (RolesList.length === 1 ? RolesList[0] : RolesList)
      } else {
        action.Roles = null
      }

      if (UsersList.length > 0) {
        if (!action.Users) {
          action.Users = {}
        }
        action.Users[type.user] = (UsersList.length === 1 ? UsersList[0] : UsersList)
      } else {
        action.Users = null
      }

      var updatedAction = utils.copy(action)
      let copyselectedOp = utils.copy(action.__selectedOp)
      this.__selectedGlobalOptions.map((option, index) => {
        if (copyselectedOp.filter(o => o.Uid === option.Uid).length !== 0 && action.__selectedOptions.filter(o => o.Uid === option.Uid).length === 0) {
          this.__selectedGlobalOptions.splice(index, 1)
        }
      })
      action.__selectedOp = utils.copy(action.__selectedOptions)
      this.updateAction(action.Id, updatedAction)
    },

    updateAction(actionId, updatedAction) {
      delete updatedAction.__selectedOptions
      delete updatedAction.__selectedContextType
      delete updatedAction.__selectedAdditionalOptions
      delete updatedAction.__o
      delete updatedAction.actionValues
      delete updatedAction.__selectedOp
      delete updatedAction._parallelRouteNo

      let payload = {
        Id: actionId,
        Action: updatedAction
      }

      this.$emit('updateAction', payload)
    },

    addAction(newAction) {
      newAction.Id = this.max(this.$store.state.approvalRuleIds.actionIds) + 1
      this.$store.state.approvalRuleIds.actionIds.push(newAction.Id)
      var copyNewAction = utils.copy(newAction)

      if (this.processedActions.constructor === Array) {
        this.processedActions.push(this.applyActionContext(copyNewAction))

        const sanitizedNewAction = utils.copy(newAction)
        delete sanitizedNewAction.__selectedOptions
        delete sanitizedNewAction.__selectedContextType
        delete sanitizedNewAction.__selectedAdditionalOptions
        delete sanitizedNewAction.__o
        delete sanitizedNewAction.actionValues
        delete sanitizedNewAction.__selectedOp
        delete sanitizedNewAction._parallelRouteNo
        this.$emit('addActionLine', sanitizedNewAction)
        return
      }
    },

    matchStatus(item) {
      return item === 'true'
    },

    deleteConditionModal(action) {
      this.showDeleteModal = true
      this.deleteTarget = action
    },

    deleteActionLine() {
      this.processedActions.splice(this.processedActions.indexOf(this.deleteTarget), 1)
      this.deleteTarget.__selectedOp.map(option => {
        if (this.__selectedGlobalOptions.filter(o => o.Uid === option.Uid).length !== 0) {
          var index = this.__selectedGlobalOptions.map(op => {
            return op.Uid
          }).indexOf(option.Uid)
          this.__selectedGlobalOptions.splice(index, 1)
        }
      })
      this.$emit('deleteLine', this.deleteTarget)
      this.enableSaveButton()
    },

    copyActionLine: function(index) {
      var newAction = utils.copy(this.processedActions[index])
      const id = this.max(this.$store.state.approvalRuleIds.actionIds) + 1

      newAction.Id = id
      this.$store.state.approvalRuleIds.actionIds.push(id)

      const sanitizedNewAction = utils.copy(newAction)
      delete sanitizedNewAction.__selectedOptions
      delete sanitizedNewAction.__selectedContextType
      delete sanitizedNewAction.__selectedAdditionalOptions
      delete sanitizedNewAction.__o
      delete sanitizedNewAction.actionValues
      delete sanitizedNewAction.__selectedOp
      delete sanitizedNewAction._parallelRouteNo

      this.processedActions.splice(index + 1, 0, newAction)
      this.$emit('copyLine', sanitizedNewAction)
      this.enableSaveButton()
    },

    resetActionLine(action, e) {
      this.enableSaveButton()
      let copyselectedOp = utils.copy(action.__selectedOp)
      let copyselectedOptions = utils.copy(action.__selectedOptions)
      this.__selectedGlobalOptions.map(option => {
        if (copyselectedOp.filter(o => o.Uid === option.Uid).length !== 0 && copyselectedOptions.filter(o => o.Uid === option.Uid).length !== 0) {
          this.__selectedGlobalOptions.splice(this.__selectedGlobalOptions.indexOf(option), 1)
        }
      })
      action['@xsi:type'] = this.contextTypeMap.filter(key => contextType[key] === e.label)[0]
      action.Operator = null
      action.__selectedOptions = []
      action.__selectedContextType = ''
      action.__selectedAdditionalOptions = this.getAdditionalOptions(action)
      action.__o = [{}]
      action.__selectedOp = []
      action.Values = null
      action.Roles = {
        RoleDTO: null
      }
      action.Users = {
        UserDTO: null
      }
      action._parallelRouteNo = { label: '', id: null }
      action.ParallelRouteNo = null
      this.$store.state.routeNumbers.splice(this.$store.state.routeNumbers.indexOf(action._parallelRouteNo.id), 1)
      this.setOptions(action, e)

      var updatedAction = utils.copy(action)
      this.updateAction(action.Id, updatedAction)
    },

    resetActionOperator(action, e) {
      action.Operator = this.operatorTypeMap.filter(key => operatorType[key] === e)[0]
      var updatedAction = utils.copy(action)
      this.updateAction(action.Id, updatedAction)
    },

    changeActionOperator(action, e) {
      action.Operator = this.operatorTypeMap.filter(key => operatorType[key] === e)[0]
      var updatedAction = utils.copy(action)
      this.updateAction(action.Id, updatedAction)
      this.enableSaveButton()
    },

    changeOperator(e) {
      this.rule.ActionOperator = e === this.actionOperators[0] ? 'StepByStep' : 'Simultaneously'
      let updatedOperator = utils.copy(this.rule.ActionOperator)
      this.$emit('changeOperator', updatedOperator)
      this.enableSaveButton()
    },

    changeRouteNo(action, e) {
      if (this.$store.state.routeNumbers.indexOf(parseInt(action._parallelRouteNo.id)) > -1) {
        this.$store.state.routeNumbers.splice(this.$store.state.routeNumbers.indexOf(parseInt(action._parallelRouteNo.id)), 1)
      }
      this.$store.state.routeNumbers.push(parseInt(e.id))
      action._parallelRouteNo = typeof action.ParallelRouteNo !== 'undefined' && this.useParallelApprovalRoutes ? {label: this.routesValuesMap.filter(key => routesValues.routeNumber[key] === e.id)[0], id: parseInt(e.id)} : {label: '', id: null}
      action.ParallelRouteNo = parseInt(e.id)

      var updatedAction = utils.copy(action)
      this.updateAction(action.Id, updatedAction)
      this.enableSaveButton()
    },

    enableSaveButton() {
      approvalRuleUtils.utils.enableSaveButton(!this.$store.state.enableSaveButton)
    },

    formatLabel(value) {
      if (typeof value !== 'string') return value
      return value.replace('Program', this.programLabel)
    }
  }
}
</script>

<style scoped lang='scss'>
  .invalid {
    background: #ffb3b3 !important;
  }
@import "~@/assets/sass/_variables.scss";
</style>



// WEBPACK FOOTER //
// src/components/_modules/Approvals/Approval-rule/action.vue